import React, { PureComponent } from "react";
import PageHeaderWrapper from "../../../../components/PageHeaderWrapper";
import { FormUtils as GetAllFormFields } from "sz-react-utils";
import MasterDocUtils from "../../../../components/_utils/masterDocUtil";
import MasterDocuments from "../../../../components/_utils/masterDocuments";
import { Button, Card, Checkbox, Col, Drawer, Form, Icon, Select, Input, List, notification, Row, Tabs, Tooltip, Modal, Table } from "antd";
import _, { get } from "lodash";
import { hideLoader, showLoader } from "../../../../modules/actions";
import Request, { API_URL, LAPI_URL } from "../../../../request";
import { connect } from "react-redux";
import style from "./styles.less";
import moment from "moment";
import { T } from "antd/lib/upload/utils";
import { TableComp } from 'sz-react-utils'

const TabPane = Tabs.TabPane;
const { Option } = Select
let docLoaded = null;
let countryId = null;
let test = [];
const CheckboxGroup = Checkbox.Group;

let invoiceCounts = [1, 2, 3, 4, 5, 6, 7, 8];

@Form.create()
class AddCommDetailsInUni extends React.Component {
    state = {
        visible: true,
        universities: [],
        levelOptions: [],
        bonusAny: '',
        minimumStudents: '',
        maximumStudents: '',
        bonusType: '',
        commissionType: '',
        bonus: '',
        bonusDetails: [],
        bonusIndex: null
    }


    onClose = () => {
        this.setState({ visible: false })
        setTimeout(() => {
            this.props.onClose();
        }, 50)
    }


    loadUniversity = async () => {
        Request.loadSimpleUniversities({ sort: { instituteName: 1 } })
            .then(resp => {
                resp.arr = resp.arr.reduce((temp, vv) => {
                    temp.push({ _id: vv._id, display: vv.universityInstitutionName })
                    return temp
                }, [])

                this.setState({ 'universities': resp.arr });
                this.refreshFxn()
            })
            .catch(err => {
                console.log(err)
            })
    }

    loadLevels = async () => {
        let params = { sortField: 'levelName', sortOrder: 'ascend' }
        Request.loadSimpleLevels({ ...params })
            .then(resp => {
                let temp = [{ display: '---Select All if Same Commission Applies---', id: 'all' }];
                resp.data = resp.data.reduce((el, vv) => {
                    temp.push({ _id: vv._id, display: vv.levelName })
                    return temp
                }, [])
                this.setState({ levelOptions: resp.data })
            })
            .catch(err => {
                console.log(err)
            })
    }

    setFormValues = () => {
        let { record, form: { setFieldsValue } } = this.props;
        setTimeout(() => {
            setFieldsValue({ ...record }, () => {
                setFieldsValue({ commissionBasis: record.commissionBasis, commissionProvided: record.commissionProvided, partnerCommission: record.partnerCommission });
                setTimeout(() => {
                    setFieldsValue({ commissionProvided: record.commissionProvided, partnerCommission: record.partnerCommission });
                }, 50)
            });
        }, 50)
    }

    async componentDidMount() {
        await this.loadUniversity();
        await this.loadLevels();
        await this.setFormValues();
        // console.log(this.props);
    }


    handleSubmit = (e) => {
        let { form, record } = this.props;
        e.preventDefault();
        form.validateFieldsAndScroll(async (err, valData) => {
            let values = _.clone(valData);
            values.channelPartnerId = countryId;
            let response = await Request.updateUniCommInCP(values);
            if (response.success) {
                notification.success({
                    message: response.message
                })
            } else {
                notification.error({
                    message: response.message
                })
            }
            this.onClose();
        })
    }

    addBonusCommission = () => {
        let { totalStudents, minimumStudents, maximumStudents, bonusType, commissionType, bonus, bonusDetails } = this.state;
        if (!minimumStudents || !maximumStudents) {
            notification.error({
                message: 'Min - Max Students Required'
            })
            return false;
        } else if (!bonusType) {
            notification.error({
                message: 'Bonus Type is required'
            })
            return false;
        } else if (!commissionType) {
            notification.error({
                message: 'Commission Type is required'
            })
            return false;
        }
        bonusDetails.push({
            minimumStudents,
            maximumStudents,
            bonusType,
            commissionType,
            bonus
        })
        this.setState({
            bonusDetails: bonusDetails,
            bonusIndex: null,
            minimumStudents: null,
            maximumStudents: null,
            bonusType: null,
            commissionType: null,
            bonus: null
        });
    }

    updateBonusCommission = () => {
        let { minimumStudents, maximumStudents, bonusType, commissionType, bonus, bonusIndex, bonusDetails } = this.state;
        if (!minimumStudents || !maximumStudents) {
            notification.error({
                message: 'Min - Max Students is required'
            })
            return false;
        } else if (!bonusType) {
            notification.error({
                message: 'Bonus Type is required'
            })
            return false;
        } else if (!commissionType) {
            notification.error({
                message: 'Commission Type is required'
            })
            return false;
            // } else if(!bonus) {
            //   notification.error({
            //     message: 'Bonus is required'
            //   })
            //   return false;
        }
        if (bonusDetails[bonusIndex] !== undefined) {
            bonusDetails[bonusIndex] = {
                minimumStudents,
                maximumStudents,
                bonusType,
                commissionType,
                bonus
            };
        }
        this.setState({
            bonusDetails: bonusDetails,
            bonusIndex: null,
            totalStudents: null,
            minimumStudents: null,
            maximumStudents: null,
            bonusType: null,
            commissionType: null,
            bonus: null
        });
    }

    editBonus = (index, bonusDetail) => {
        this.setState({
            bonusIndex: index,
            minimumStudents: bonusDetail.minimumStudents,
            maximumStudents: bonusDetail.maximumStudents,
            bonusType: bonusDetail.bonusType,
            commissionType: bonusDetail.commissionType,
            bonus: bonusDetail.bonus
        });
    }

    removeBonus = (index) => {
        let { bonusDetails } = this.state;
        if (bonusDetails[index] !== undefined) {
            bonusDetails.splice(index, 1);
        }
        this.setState({
            bonusDetails: bonusDetails
        });
    }

    updateCommissionFromUniversity = () => {
        const { form: { getFieldValue, setFieldsValue } } = this.props;

        const partnerCommission = Number(getFieldValue('partnerCommission')) || 0;
        const commissionProvided = Number(getFieldValue('commissionProvided')) || 0;
        const basis = getFieldValue('commissionBasis');
        const type = getFieldValue('commissionTypeFrom');

        if (type === "Percentage" && basis === "Gross") {
            const commissionPercent = (partnerCommission * commissionProvided) / 100;
            setFieldsValue({
                commissionFromUniversity: Number(commissionPercent.toFixed(2)) // numeric only
            });
        }
    }




    render() {
        let { visible, universities, levelOptions, bonusAny, bonusDetails, bonusIndex } = this.state;
        let { form: { getFieldDecorator, setFieldsValue, getFieldValue } } = this.props;
        const inputTypes = {
            fields: [
                {
                    label: 'Select University ',
                    key: 'universityId',
                    required: true,
                    type: 'select',
                    showSearch: true,
                    disabled: true,
                    options: universities,
                    onChange: v => {
                        this.props.form.setFieldsValue({
                            universityId: v
                        })
                    }
                },
                {
                    label: 'Course Level',
                    key: 'courseLevelId',
                    type: 'select',
                    required: true,
                    showSearch: true,
                    mode: 'multiple',
                    disabled: false,
                    options: levelOptions,
                    onChange: v => {
                        let val = v ? v : [];
                        if (v && v.length && v.includes("all")) {
                            if (v.length === levelOptions.length) {
                                val = [];
                            } else {
                                val = levelOptions.slice(1).map(levelOption => levelOption._id);
                            }
                        }
                        this.props.form.setFieldsValue({
                            courseLevelId: val
                        })
                    }
                },
                {
                    label: 'Total Number of Invoices',
                    key: 'noOfInvoice',
                    type: 'select',
                    required: true,
                    disabled: false,
                    options: invoiceCounts,
                    onChange: v => {
                        this.props.form.setFieldsValue({
                            noOfInvoice: v
                        })
                    }
                },
                {
                    label: 'Invoice(s) Per Year',
                    key: 'invoicePerYear',
                    type: 'select',
                    required: true,
                    disabled: false,
                    options: invoiceCounts,
                    onChange: v => {
                        this.props.form.setFieldsValue({
                            invoicePerYear: v
                        })
                    }
                },
                {
                    label: 'Commission Type',
                    key: 'commissionTypeFrom',
                    type: 'select',
                    required: true,
                    showSearch: true,
                    disabled: false,
                    options: [
                        'Flat', 'Percentage'
                    ],
                    onChange: v => {
                        this.props.form.setFieldsValue({
                            commissionTypeFrom: v
                        })
                    }
                },
                {
                    label: 'Commission Calculated On',
                    key: 'commissionBasis',   // ✅ fixed spelling
                    type: 'select',
                    hidden: !getFieldValue('commissionTypeFrom') || getFieldValue('commissionTypeFrom') === "Flat",
                    required: getFieldValue('commissionTypeFrom') === "Percentage",
                    showSearch: true,
                    disabled: false,
                    options: [
                        { _id: 'Net', display: 'Net Percentage' },
                        { _id: 'Gross', display: 'Gross Percentage' },
                    ],
                    onChange: v => {
                        this.props.form.setFieldsValue({
                            commissionBasis: v   // ✅ matches the key
                        })
                    }
                },
                {
                    label: 'Partner Commission',
                    key: 'partnerCommission',
                    type: 'inputNumber',  // ensures numeric value
                    hidden: !getFieldValue('commissionBasis') || getFieldValue('commissionBasis') === "Net",
                    required: getFieldValue('commissionBasis') === "Gross",
                    onChange: v => {
                        // v is already a number, store directly
                        setFieldsValue({ partnerCommission: v.target.value }, () => {
                            this.updateCommissionFromUniversity()
                        });
                    }
                },
                {
                    label: 'Commission Provided',
                    key: 'commissionProvided',
                    type: 'inputNumber',  // ensures numeric value
                    hidden: !getFieldValue('commissionBasis') || getFieldValue('commissionBasis') === "Net",
                    required: getFieldValue('commissionBasis') === "Gross",
                    onChange: v => {
                        // v is already a number, store directly
                        setFieldsValue({ commissionProvided: v.target.value }, () => {
                            this.updateCommissionFromUniversity()
                        });
                    }
                },
                {
                    label: 'Commission Amount / %',
                    key: 'commissionFromUniversity',
                    required: true,
                    disabled: (() => {
                        const type = getFieldValue('commissionTypeFrom');
                        const basis = getFieldValue('commissionBasis');

                        if (type === "Flat") return false;
                        if (type === "Percentage" && basis === "Gross") return true;
                        if (type === "Percentage" && basis === "Net") return false;
                        return true;
                    })(),
                },
                // {
                //     label: 'Commission Amount / %',
                //     key: 'commissionFromUniversity',
                //     required: true,
                //     disabled: !getFieldValue('commissionBasis') || getFieldValue('commissionBasis') !== "Net",
                // },
                {
                    label: 'Bonus If any',
                    key: 'bonusAny',
                    type: 'select',
                    required: true,
                    showSearch: true,
                    disabled: false,
                    options: [
                        'Yes', 'No'
                    ],
                    onChange: v => {
                        this.setState({ bonusAny: v });
                        this.props.form.setFieldsValue({
                            bonusAny: v
                        })
                    }
                }
            ]
        };
        return (
            <Drawer
                title={
                    <div>
                        <React.Fragment>
                            Commission Setup for {this.props.record.universityInstitutionName}
                        </React.Fragment>
                    </div>
                }
                placement="right"
                closable={true}
                onClose={this.onClose}
                width={1000}
                visible={visible}>
                <Card bordered={true}>
                    <Form onSubmit={this.handleSubmit}>
                        <GetAllFormFields apiurl={LAPI_URL} inputSchema={inputTypes} getFieldDecorator={getFieldDecorator} />
                        {
                            bonusAny == 'Yes' ?
                                <div>
                                    <Card title="Bonus Details">
                                        <div>
                                            <Row>
                                                <Col span={3}>
                                                    <label>Min Students</label>
                                                    <Input type={'number'}
                                                        placeholder={"Minimum"}
                                                        value={this.state.minimumStudents}
                                                        onChange={(ei) => {
                                                            this.setState({ minimumStudents: ei.target.value });
                                                        }} />
                                                    {/* <label>Total Students</label>
                    <Input
                    type={'number'}
                    placeholder={"Total Students"}
                    value={this.state.totalStudents}
                    onChange={(ei) => {
                        this.setState({ totalStudents: ei.target.value });
                    }}
                    /> */}
                                                </Col>
                                                <Col span={3}>
                                                    <label>Max Students</label>
                                                    <Input type={'number'}
                                                        placeholder={"Minimum"}
                                                        value={this.state.maximumStudents}
                                                        onChange={(ei) => {
                                                            this.setState({ maximumStudents: ei.target.value });
                                                        }} />
                                                    {/* <label>Total Students</label>
                        <Input
                        type={'number'}
                        placeholder={"Total Students"}
                        value={this.state.totalStudents}
                        onChange={(ei) => {
                            this.setState({ totalStudents: ei.target.value });
                        }}
                        /> */}
                                                </Col>
                                                <Col span={5}>
                                                    <label>Bonus Type</label>
                                                    <Select
                                                        placeholder="Select Bonus Type"
                                                        showSearch={true}
                                                        value={
                                                            this.state.bonusType
                                                        }
                                                        onChange={(ei) => {
                                                            this.setState({
                                                                bonusType: ei
                                                            });
                                                        }}
                                                    >
                                                        <Option value={'Per Student'}> Per Student </Option>
                                                        <Option value={'Total Student'}> Total Student </Option>
                                                    </Select>
                                                </Col>
                                                <Col span={5}>
                                                    <label>Commission Type</label>
                                                    <Select
                                                        placeholder="Select Commission Type"
                                                        showSearch={true}
                                                        value={
                                                            this.state.commissionType
                                                        }
                                                        onChange={(ei) => {
                                                            this.setState({
                                                                commissionType: ei
                                                            });
                                                        }}
                                                    >
                                                        <Option value={'flat'}> Flat </Option>
                                                        <Option value={'percantage'}> Percantage </Option>
                                                    </Select>
                                                </Col>
                                                <Col span={5}>
                                                    <label>Commission</label>
                                                    <Input
                                                        type={'Bonus'}
                                                        placeholder={"Bonus"}
                                                        value={this.state.bonus}
                                                        onChange={(ei) => {
                                                            this.setState({ bonus: ei.target.value });
                                                        }}
                                                    />
                                                </Col>
                                                <Col span={2}>
                                                    <label>&nbsp;&nbsp;&nbsp;</label>
                                                    {
                                                        bonusIndex != null ?
                                                            <Button
                                                                type="primary"
                                                                style={{ marginBottom: 10, marginLeft: '1%' }}
                                                                loading={this.props.loading}
                                                                onClick={() => {
                                                                    this.updateBonusCommission()
                                                                }}>
                                                                Update
                                                            </Button>
                                                            :
                                                            <Button
                                                                type="primary"
                                                                style={{ marginBottom: 10, marginLeft: '1%' }}
                                                                loading={this.props.loading}
                                                                onClick={() => {
                                                                    this.addBonusCommission()
                                                                }}>
                                                                Add
                                                            </Button>
                                                    }

                                                </Col>
                                            </Row>
                                            <Row>
                                                <Card title="Bonus List">
                                                    <table className="table-bonus-list">
                                                        <thead>
                                                            <tr>
                                                                {/* <th>Total Students</th> */}
                                                                <th>Min - Max Students</th>
                                                                {/* <th>Maximum</th> */}
                                                                <th>Bonus Type</th>
                                                                <th>Commission Type</th>
                                                                <th>Bonus</th>
                                                                <th>Action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                bonusDetails && bonusDetails.map((bonusDetail, index) => {
                                                                    return (
                                                                        <tr key={index}>
                                                                            <td>{`${bonusDetail.minimumStudents} - ${bonusDetail.maximumStudents}`}</td>
                                                                            {/* <td>{bonusDetail.totalStudents}</td> */}
                                                                            {/* <td>{bonusDetail.minimum}</td>
                                        <td>{bonusDetail.maximum}</td> */}
                                                                            <td>{bonusDetail.bonusType}</td>
                                                                            <td>{bonusDetail.commissionType}</td>
                                                                            <td>{bonusDetail.bonus}</td>
                                                                            <td><a onClick={() => this.editBonus(index, bonusDetail)}>Edit</a> | <a onClick={() => this.removeBonus(index)}>Remove</a></td>
                                                                        </tr>
                                                                    )
                                                                })
                                                            }
                                                        </tbody>
                                                    </table>
                                                </Card>
                                            </Row>
                                        </div>
                                    </Card>
                                </div>
                                : null
                        }

                        <Button
                            type=""
                            htmlType="submit"
                            style={{
                                marginBottom: 10,
                                marginLeft: '33%',
                                backgroundColor: 'green',
                                color: 'white'
                            }}
                            loading={this.props.loading}>
                            SAVE
                        </Button>
                    </Form>
                </Card>
            </Drawer>
        )
    }
}

@Form.create()
class ImportCommDrawer extends React.Component {
    state = {
        visible: true
    }


    onClose = () => {
        setTimeout(() => {
            this.props.onClose();
        }, 50)
    }

    handleSubmit = (e) => {
        e.preventDefault();
        let { form, channelPartnerId } = this.props;
        form.validateFieldsAndScroll(async (err, valData) => {
            let values = _.clone(valData);
            values.channelPartnerId = channelPartnerId;
            let response = await Request.importChannelPartnerComm(values);
            if (response.success) {
                notification.success({
                    message: response.message
                })
            } else {
                notification.error({
                    message: response.message
                })
            }
            this.onClose();
        })
    }


    render() {
        let { visible } = this.state;
        let { form: { getFieldDecorator } } = this.props;
        let inputTypes = {
            fields: [
                {
                    label: 'Upload Excel',
                    key: 'excelFile',
                    type: 'file'
                }
            ]
        }
        return (
            <Drawer
                title={"Import Commission"}
                placement="right"
                closable={true}
                onClose={this.onClose}
                width={1000}
                visible={visible}>
                <Card bordered={true}>
                    <Form onSubmit={this.handleSubmit}>
                        <GetAllFormFields inputSchema={inputTypes} apiurl={LAPI_URL} getFieldDecorator={getFieldDecorator} />
                        <Button
                            type=""
                            htmlType="submit"
                            style={{
                                marginBottom: 10,
                                marginLeft: '33%',
                                backgroundColor: 'green',
                                color: 'white'
                            }}
                            loading={this.props.loading}>
                            SAVE
                        </Button>
                    </Form>
                </Card>
            </Drawer>
        )
    }
}




@Form.create()
class AddPartner extends PureComponent {
    constructor(props) {
        super(props);
        this.uniCommTable = React.createRef();
        this.state = {
            showSave: 1,
            showFiles: 0,
            loading: false,
            refreshChild: false,
            showChooseUniDrawer: false,
            choosedUniRecord: {},
            phoneCodes: [],
            uniCommArr: [],
            countries: [],
            inputTypes: [
                {
                    tabTitle: "General Info",
                    fields: [
                        {
                            label: "Partner Name ",
                            key: "channelPartnerName",
                            required: true,
                        },
                        {
                            label: "Address",
                            key: "channelAddress",
                            type: "textArea",
                            rows: 10,
                            required: true,
                        },
                        {
                            label: "Select Country ",
                            key: "channelCountryId",
                            required: true,
                            showSearch: true,
                            type: "select",
                            options: [],
                            onChange: (v) => {
                                this.props.form.setFieldsValue({
                                    channelCountryId: v,
                                    channelStateId: null,
                                    channelCityId: null,
                                });
                                this.loadStates(v);
                                this.getDetails(v);
                            },
                        },
                        {
                            label: "Select State",
                            key: "channelStateId",
                            required: true,
                            showSearch: true,
                            type: "select",
                            options: [],
                            onChange: (v) => {
                                this.props.form.setFieldsValue({
                                    channelStateId: v,
                                    channelCityId: null,
                                });
                                this.loadCities(v);
                            },
                        },

                        {
                            label: "Select City",
                            key: "channelCityId",
                            showSearch: true,
                            required: true,
                            type: "select",
                            options: [],
                            onChange: (v) => {
                                this.props.form.setFieldsValue({
                                    channelCityId: v,
                                });
                            },
                        },
                        {
                            label: 'Partner Type',
                            key: 'partnerType',
                            type: 'select',
                            required: true,
                            options: ["Domestic", "International"],
                            onChange: v => {
                                this.props.form.setFieldsValue({ partnerType: v });
                            }
                        },
                        {
                            label: 'Agent Code',
                            key: 'agentCode',
                            type: 'text'
                        },
                        {
                            label: 'Preferred Partner',
                            key: 'preferredPartner',
                            type: 'checkbox',
                            onClick: (v) => {
                                this.props.form.setFieldsValue({
                                    preferredPartner: v.target.checked,
                                });
                            },
                        },
                        {
                            label: "Select Company Partner",
                            key: "channelPartnerId",
                            showSearch: true,
                            type: "select",
                            options: [],
                            hidden: true,
                            onChange: (v) => {
                                this.props.form.setFieldsValue({
                                    channelPartnerId: v
                                });
                                this.loadCities(v);
                            },
                        },
                        {
                            label: 'Employee Incentive',
                            key: 'employeeIncentive',
                            type: 'switch',
                            onChange: v => {
                                this.props.form.setFieldsValue({ employeeIncentive: v })
                            }
                        }
                    ],
                },
                {
                    tabTitle: "Contact Details",
                    fields: [
                        {
                            label: "Name",
                            key: "channelNameOne",
                            prefixComp: <h3>Admission Person1</h3>,
                        },
                        {
                            label: "Country Code",
                            key: "contactPhoneOneCode",
                            type: "select",
                            showSearch: true,
                            options: [],
                            onChange: (v) => {
                                this.props.form.setFieldsValue({ contactPhoneOneCode: v });
                            },
                        },
                        { label: "Phone ", key: "channelPhoneOne" },
                        { label: "Email ", key: "channelEmailOne" },

                        {
                            label: "Name",
                            key: "channelNameTwo",
                            prefixComp: <h3>Admission Person2</h3>,
                        },
                        {
                            label: "Country Code",
                            key: "contactPhoneTwoCode",
                            type: "select",
                            showSearch: true,
                            options: [],
                            onChange: (v) => {
                                this.props.form.setFieldsValue({ contactPhoneTwoCode: v });
                            },
                        },
                        { label: "Phone", key: "channelPhoneTwo" },
                        { label: "Email", key: "channelEmailTwo" },

                        {
                            label: "Name",
                            key: 'channelMarketingPersonName',
                            key: "channelMarketingPersonPhone",
                            prefixComp: <h3>Marketing Person</h3>,
                        },
                        {
                            label: "Country Code",
                            key: "channelMarketingPhoneCode",
                            type: "select",
                            showSearch: true,
                            options: [],
                            onChange: (v) => {
                                this.props.form.setFieldsValue({ contactPhoneThreeCode: v });
                            },
                        },
                        { label: "Phone", key: "channelMarketingPersonPhone" },
                        { label: "Email", key: "ChannelMarketingPersonEmail" },

                        {
                            label: "Name",
                            key: "channelAccountPersonName",
                            prefixComp: <h3>Accounts Person</h3>,
                        },
                        {
                            label: "Country Code",
                            key: "contactAccountPhoneCode",
                            type: "select",
                            showSearch: true,
                            options: [],
                            onChange: (v) => {
                                this.props.form.setFieldsValue({ contactAccountPhoneCode: v });
                            },
                        },
                        { label: "Phone", key: "channelAccountPersonPhone" },
                        { label: "Email", key: "channelAccountPersonEmail" },
                        {
                            label: 'GST Number',
                            key: 'gstNumber',
                        },
                        {
                            label: 'Pan Number',
                            key: 'panNumber'
                        },
                        {
                            label: 'Invoice Code Name',
                            key: 'invoiceCodeName'
                        },
                        {
                            label: 'Invoice Code Value',
                            key: 'invoiceCodeValue',
                        },
                        {
                            label: 'Code Service Name',
                            key: 'codeServiceName'
                        },
                        {
                            label: 'Status',
                            key: 'invoiceToStatus',
                            type: 'select',
                            options: ['Active', 'Inactive'],
                            onChange: (v) => {
                                this.props.form.setFieldsValue({ invoiceToStatus: v });
                            }
                        }
                    ],
                },
            ],
            uniArr: [],
            uniCommArr: [],
            uniArrOrig: [],
            checkedList: [],
            uniCommCheckedList: [],
            indeterminate: true,
            checkAll: false,
            isAgreementExpire: false,
            mapped: [],
            choosenArr: [],
            partners: [],
            showImportDrawer: false,
            applicantsList: [],
        };

        this.loadCountries();
        this.loadUniversities();
        this.loadCompanyPartners();
    }



    handleSubmit = (e) => {
        const { dispatch, form } = this.props;
        e.preventDefault();
        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                let values = _.clone(valData);
                values.uniArr = this.state.checkedList;
                values.invoiceDetails = this.state.applicantsList
                if (countryId) {
                    values = { ...values, _id: countryId, };
                    this.setState({ loading: true })
                    dispatch(showLoader());

                    let x = await Request.updatePartner(values);
                    dispatch(hideLoader());
                    this.setState({ loading: false })
                    if (!x.error) {
                        notification.success({
                            message: "Success",
                            description: x.msg,
                        });
                    } else {
                        notification.error({
                            message: "Error Saving",
                            description: x.msg,
                        });
                    }
                } else {
                    this.setState({ loading: true })
                    dispatch(showLoader());

                    let x = await Request.addPartner(values);

                    dispatch(hideLoader());
                    this.setState({ loading: false })
                    if (!x.error) {
                        notification.success({
                            message: "Success",
                            description: x.msg,
                        });

                        form.resetFields();
                        this.uncheck();

                        // dispatch('/all-countries')
                    } else {
                        notification.error({
                            message: "Error Saving",
                            description: x.msg,
                        });
                    }
                }
            }
        });
    };

    // handleReferenceSubmit = () => {
    //     let { form } = this.props;
    //     let billingDetailValues = form.getFieldsValue([
    //         'type',
    //         'invoiceToName',
    //         'invoiceAddress',
    //         'kindAttention',
    //         'invoiceToEmail',
    //         'invoiceToPhoneCode',
    //         'invoiceToPhone',
    //         'invoiceToCategory',
    //         'default'
    //     ]);

    //     let requiredFields = [
    //         'type',
    //         'invoiceToName',
    //         'invoiceAddress',
    //         'kindAttention',
    //         'invoiceToEmail',
    //         'invoiceToPhoneCode',
    //         'invoiceToPhone',
    //         'invoiceToCategory'
    //     ];

    //     let missingField = requiredFields.find(field => {
    //         const value = billingDetailValues[field];
    //         return value === undefined || value === null || value === '';
    //     });

    //     if (missingField) {
    //         notification.error({
    //             message: `Please enter ${missingField}`
    //         });
    //         return;
    //     }
    //     if (!billingDetailValues.default) {
    //         billingDetailValues.default = false;
    //     }
    //     let applicantsList = this.state.applicantsList
    //     applicantsList.push(billingDetailValues)
    //     this.setState({ applicantsList, showApplicantModal: false }, () => {
    //         this.props.form.setFieldsValue({
    //             type: null,
    //             invoiceToName: null,
    //             invoiceAddress: null,
    //             kindAttention: null,
    //             invoiceToEmail: null,
    //             invoiceToPhoneCode: null,
    //             invoiceToPhone: null,
    //             invoiceToCategory: null
    //         })
    //     });

    // }

    handleReferenceSubmit = () => {

        let { form } = this.props;

        let billingDetailValues = form.getFieldsValue([
            'type',
            'invoiceToName',
            'invoiceAddress',
            'kindAttention',
            'invoiceToEmail',
            'invoiceToPhoneCode',
            'invoiceToPhone',
            'invoiceToCategory',
            'default'
        ]);

        let requiredFields = [
            'type',
            'invoiceToName',
            'invoiceAddress',
            'kindAttention',
            'invoiceToEmail',
            'invoiceToPhoneCode',
            'invoiceToPhone',
            'invoiceToCategory'
        ];

        let missingField = requiredFields.find(field => {
            const value = billingDetailValues[field];
            return value === undefined || value === null || value === '';
        });

        if (missingField) {
            notification.error({
                message: `Please enter ${missingField}`
            });
            return;
        }

        if (!billingDetailValues.default) {
            billingDetailValues.default = false;
        }

        let applicantsList = [...this.state.applicantsList];

        if (this.state.editIndex !== null) {

            // UPDATE EXISTING
            applicantsList[this.state.editIndex] = billingDetailValues;

        } else {

            // ADD NEW
            applicantsList.push(billingDetailValues);
        }

        this.setState({
            applicantsList,
            showApplicantModal: false,
            editIndex: null
        }, () => {

            this.props.form.setFieldsValue({
                type: null,
                invoiceToName: null,
                invoiceAddress: null,
                kindAttention: null,
                invoiceToEmail: null,
                invoiceToPhoneCode: null,
                invoiceToPhone: null,
                invoiceToCategory: null,
                default: false
            });
        });
    };

    removeCommissionRow = (index) => {
        this.setState((prevState) => {
            const updatedCommissions = [...prevState.applicantsList]; // copy array
            updatedCommissions.splice(index, 1); // remove item at index
            return { applicantsList: updatedCommissions };
        });
    };

    callback = (key) => {
        // Handle showSave
        let { inputTypes } = this.state;
        if (key === 4 || key === 6) {
            this.setState({ showSave: 0 });
        } else {
            this.setState({ showSave: 1 });
        }

        // For key == 2
        if (countryId && key === "2") {
            var tempObj = {};
            for (var i = 0; i < inputTypes[1].fields.length; i++) {
                var f = inputTypes[1].fields[i];
                tempObj[f.key] = docLoaded && docLoaded[f.key];
            }
            setTimeout(() => {
                this.props.form.setFieldsValue(tempObj);
            }, 10);
        }

        // For key == 5
        if (countryId && key === "5") {
            if (docLoaded && docLoaded.isAgreementExpire) {
                this.setState({ isAgreementExpire: docLoaded.isAgreementExpire });
            }

            var tempObj = {
                paymentUpload: docLoaded && docLoaded.paymentUpload && docLoaded.paymentUpload.length > 0 ? docLoaded.paymentUpload : [],
                grossCommAmountType: docLoaded && docLoaded.grossCommAmountType,
                grossCommAmount: docLoaded && docLoaded.grossCommAmount,
                paymentTimeline: docLoaded && docLoaded.paymentTimeline,
                commission: docLoaded && docLoaded.commission,
                paymentTerms: docLoaded && docLoaded.paymentTerms,
                enrollmentExpiry: docLoaded && docLoaded.enrollmentExpiry ? moment(docLoaded.enrollmentExpiry) : null,
                agreementSigningDate: docLoaded && docLoaded.agreementSigningDate ? moment(docLoaded.agreementSigningDate) : null,
                paymentUploadCommissionPage: docLoaded && docLoaded.paymentUploadCommissionPage && docLoaded.paymentUploadCommissionPage.length > 0 ? docLoaded.paymentUploadCommissionPage : [],
                isAgreementExpire: docLoaded && docLoaded.isAgreementExpire ? docLoaded.isAgreementExpire : false
            };

            setTimeout(() => {
                this.props.form.setFieldsValue(tempObj);
            }, 100);
        }


    };

    setFormValues = async (countryId) => {
        try {
            let { doc } = await Request.getPartner(countryId);
            console.log(doc.files);

            if (doc) {
                docLoaded = doc;

                let tempObj = {};
                let inputTypes = this.state.inputTypes;
                _.each(inputTypes, (val, kk) => {
                    if (kk == "0") {
                        _.each(inputTypes[0].fields, (v, k) => {
                            tempObj[v.key] = docLoaded[v.key];
                            if (v.key == "preferredPartner") {
                                v.defaultChecked = docLoaded[v.key];
                            }

                        });
                    }
                });

                tempObj.paymentUpload = docLoaded.paymentUpload;
                tempObj.commission = docLoaded.commission;
                tempObj.paymentTerms = docLoaded.paymentTerms;

                this.setState({ checkedList: docLoaded.uniArr, uniCommArr: docLoaded.uniCommArr, applicantsList: docLoaded.invoiceDetails ? docLoaded.invoiceDetails : [] });

                setTimeout(() => {
                    this.fillCheckArray();
                }, 1000);

                this.loadStates(docLoaded["channelCountryId"]);
                this.loadCities(docLoaded["channelStateId"]);
                this.props.form.setFieldsValue(tempObj);
            }
        } catch (e) {
            console.error(e);
        }
    };
    loadUniversities = async () => {
        Request.loadSimpleUniversities({ sort: { instituteName: 1 } })
            .then((resp) => {
                resp.arr = resp.arr.reduce((temp, vv) => {
                    temp.push({
                        _id: vv._id,
                        label: vv.universityInstitutionName,
                        universityPartnership: vv.universityPartnership,
                        value: vv._id,
                        key: vv._id,
                    });

                    return temp;
                }, []);
                this.setState({ uniArr: resp.arr, uniArrOrig: resp.arr });
            })
            .catch((err) => {
                console.error(err);
            });
    };

    loadCompanyPartners = async () => {
        Request.loadCompanyPartners()
            .then((resp) => {
                let partners = [];
                let inputTypes = this.state.inputTypes;
                if (resp.data && resp.data.length > 0) {
                    resp.data.map((partner) => {
                        partners.push({ id: partner.business_to_id, display: partner.business_to_name });
                    });
                    inputTypes[0]["fields"][6].options = partners;
                    inputTypes[0]["fields"][6].hidden = false;
                } else {
                    inputTypes[0]["fields"][6].hidden = true;
                }
                this.setState({ inputTypes: inputTypes });
            })
            .catch((err) => {
                console.error(err);
            });
    }

    loadCountries = () => {
        let params = {
            results: 200,
            sortField: "countryName",
            sortOrder: "ascend",
        };

        Request.getCountriesWithoutAuth(params)
            .then((resp) => {
                let phoneCodes = [];
                resp.data = resp.data.reduce((temp, vv) => {
                    temp.push({ _id: vv._id, display: vv.countryName });
                    if (vv.countryPhoneCode) {
                        phoneCodes.push(vv.countryPhoneCode);
                    }
                    return temp;
                }, []);
                let inputTypes = this.state.inputTypes;
                inputTypes[0]["fields"][2].options = resp.data;
                inputTypes[1]['fields'][16].options = phoneCodes;
                inputTypes[1]['fields'][1].options = phoneCodes;
                inputTypes[1]['fields'][5].options = phoneCodes;
                inputTypes[1]['fields'][9].options = phoneCodes;
                inputTypes[1]['fields'][13].options = phoneCodes;
                this.setState({ inputTypes: inputTypes, countries: resp.data, phoneCodes: phoneCodes });
                this.refreshFxn();
            })
            .catch((err) => {
                console.error(err);
            });
    };
    loadStates = (id) => {
        Request.loadStates(id)
            .then((daa) => {
                daa.result = daa.result.reduce((total, val) => {
                    total.push({
                        _id: val._id,
                        key: val._id,
                        display: val.stateName,
                    });
                    return total;
                }, []);

                let inputTypes = this.state.inputTypes;
                inputTypes[0]["fields"][3].options = daa.result;
                this.setState({ inputTypes: inputTypes });
                this.refreshFxn();
            })
            .catch((err) => {
            });
    };

    getDetails = (id) => {
        let { countries } = this.state;
        let foundCountry = countries.find((val) => val._id === id);
        // console.log(foundCountry);
    }
    loadCities = (id) => {
        Request.loadCities(id)
            .then((daa) => {
                daa.result = daa.result.reduce((total, val) => {
                    total.push({
                        _id: val._id,
                        key: val._id,
                        display: val.cityName,
                    });
                    return total;
                }, []);
                let inputTypes = this.state.inputTypes;
                inputTypes[0]["fields"][4].options = daa.result;
                this.setState({ inputTypes: inputTypes });
                this.refreshFxn();
            })
            .catch((err) => {
            });
    };
    checkUni = (checkedList) => {
        const plainOptions = this.state.uniArr;
        let newCheckedList = [];
        if (plainOptions.length !== this.state.uniArrOrig.length) {
            const notPresentInCurrentCheckedList = this.state.checkedList.filter(
                (item) => checkedList.indexOf(item) === -1
            );

            newCheckedList = notPresentInCurrentCheckedList.filter(
                (item) => !plainOptions.find((item1) => item1._id === item)
            );

        }
        this.setState({
            checkedList: [...newCheckedList, ...checkedList],

            indeterminate:
                !!checkedList.length && checkedList.length < plainOptions.length,
            checkAll: checkedList.length === plainOptions.length,
        });

        this.fillCheckArray();
    };

    exportChannelPartnerComm = async () => {
        let response = await Request.exportChannelPartnerComm({ countryId });
        if (!response.error) {
            window.open(response.url)
        }
    }

    showCommImport = () => {
        this.setState({ showImportDrawer: true });
    }

    closeCommImport = () => {
        this.setState({ showImportDrawer: false })
    }

    refreshFxn = () => {
        this.setState({ refreshChild: !this.state.refreshChild });
    };
    onCheckAllChange = (e) => {
        let above30 = this.state.uniArr.reduce((total, amount) => {
            total.push(amount.key);
            return total;
        }, []);

        this.setState({
            checkedList: e.target.checked
                ? [...new Set([...this.state.checkedList, ...above30])]
                : [],
            indeterminate: false,
            checkAll: e.target.checked,
        });
        this.fillCheckArray();
    };


    closeChoosedUniDrawer = () => {
        this.setState({ showChooseUniDrawer: false, choosedUniRecord: {} }, () => {
            this.setFormValues(countryId)
        });
    }

    fillCheckArray = async () => {
        setTimeout(() => {
            test = [];
            _.each(this.state.checkedList, (val) => {
                let finddd = _.find(this.state.uniArrOrig, (ll) => {
                    return ll.key == val;
                });
                if (finddd) {
                    test.push(finddd);
                }
            });
            this.setState({ mapped: test, choosenArr: test });
        }, 500);
    };

    uncheck = () => {
        this.setState({
            checkedList: [],
            indeterminate: false,
            checkAll: false,
        });
        this.fillCheckArray();
    };
    filter = (e) => {
        let temp = this.state.uniArrOrig.filter((str) => {
            let strValue = new RegExp(e.target.value, "ig");
            return str.label.match(strValue);

            // return str.label.includes(strValue)
        });

        this.setState({ uniArr: temp });
    };

    componentDidMount() {
        let searchParams = new URLSearchParams(this.props.search);
        countryId = searchParams.get("id");
        if (countryId) {
            this.setState({ showFiles: 1 });
            this.setFormValues(countryId);
        }
    }

    showCommissionDrawer(record) {
        { this.setState({ showChooseUniDrawer: true, choosedUniRecord: record }) }
    }

    getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={(e) =>
                        setSelectedKeys(e.target.value ? [e.target.value] : [])
                    }
                    onPressEnter={() => confirm()}
                    style={{ width: 200, marginBottom: 8, display: "block" }}
                />
                <Button
                    type="primary"
                    size="small"
                    style={{ width: 90, marginRight: 8 }}
                    onClick={() => confirm()}
                >
                    Search
                </Button>
                <Button
                    size="small"
                    style={{ width: 90 }}
                    onClick={() => clearFilters()}
                >
                    Reset
                </Button>
            </div>
        ),
        filterIcon: (filtered) => (
            <Icon type="search" style={{ color: filtered ? "#1890ff" : undefined }} />
        ),
        onFilter: (value, record) => {
            const recordValue = record[dataIndex];
            if (!recordValue) return false;
            return recordValue
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase());
        }
    });

    editApplicant = (record, index) => {

        this.setState({
            showApplicantModal: true,
            editIndex: index
        });

        this.props.form.setFieldsValue({
            type: record.type,
            invoiceToName: record.invoiceToName,
            invoiceAddress: record.invoiceAddress,
            kindAttention: record.kindAttention,
            invoiceToEmail: record.invoiceToEmail,
            invoiceToPhoneCode: record.invoiceToPhoneCode,
            invoiceToPhone: record.invoiceToPhone,
            invoiceToCategory: record.invoiceToCategory,
            default: record.default
        });
    };


    render() {
        const { submitting } = this.props;
        const {
            form: { getFieldDecorator, getFieldValue, setFieldsValue },
        } = this.props;

        const choosedUniColumn = [
            {
                title: 'Sr. No',
                key: 'serialNumber',
                render: (text, record, index) => (
                    <div>{index + 1}</div>
                )
            },
            {
                title: 'University Name',
                key: 'universityInstitutionName',
                dataIndex: 'universityInstitutionName',
                ...this.getColumnSearchProps('universityInstitutionName')
            },
            {
                title: 'University Country',
                key: 'universityCountry',
                dataIndex: 'universityCountry',
                ...this.getColumnSearchProps('universityCountry')
            },
            {
                title: 'University Type',
                key: 'universityType',
                dataIndex: 'universityType',
                ...this.getColumnSearchProps('universityType')
            },
            {
                title: 'University Category',
                key: 'universityCategory',
                dataIndex: 'universityCategory',
                ...this.getColumnSearchProps('universityCategory')
            },
            {
                title: 'Net Commission',
                key: 'commissionTypeFrom',
                render: (text, record) => (
                    <div>
                        {record.commissionFromUniversity > 0 ? record.commissionFromUniversity : null}
                        {record.commissionTypeFrom ? ` (${record.commissionTypeFrom})` : null}
                    </div>
                )
            },
            {
                title: 'Action',
                key: 'operation',
                render: (text, record) => {
                    return (
                        <Tooltip title="Add Commission Details">
                            <Button
                                size="small"
                                icon="forward"
                                shape="circle"
                                onClick={() => this.showCommissionDrawer(record)}
                            />
                        </Tooltip>
                    );
                }
            }
        ];

        const paymentInputFields = {
            fields: [
                {
                    label: 'Commission Type',
                    key: 'grossCommAmountType',
                    type: 'select',
                    options: ['Percentage', 'Flat'],
                    prefixComp: <h3>Commission Details</h3>,
                    onChange: v => {
                        setFieldsValue({ grossCommAmountType: v })
                    }
                },
                {
                    label: 'Gross Commission Amount',
                    key: 'grossCommAmount',
                    type: 'number',
                },
                {
                    label: "Commission",
                    key: "commission",
                    type: "number",
                    prefixComp: <small>Commission Amount from CP</small>,
                    rightComp: <span style={{ paddingLeft: "5px" }}>%</span>,
                },
                {
                    label: "PAYMENT Terms",
                    key: "paymentTerms",
                    type: "textArea",
                    rows: "5",
                },
                {
                    label: 'Payment Due Post Submission of Invoice (Days)',
                    key: 'paymentTimeline',
                    required: true,
                    type: 'number',
                },
                {
                    label: "Agreement",
                    key: "paymentUpload",
                    type: "file",
                    required: true,
                },
                {
                    label: 'Agreement Commission Page Document',
                    key: 'paymentUploadCommissionPage',
                    type: 'file',
                    required: true,
                },
                {
                    label: 'Signing Date',
                    key: 'agreementSigningDate',
                    required: true,
                    type: 'date',
                    format: 'DD-MMM-YYYY'
                },
                {
                    label: 'Does This Agreement has Expiry?',
                    key: 'isAgreementExpire',
                    default: false,
                    required: true,
                    type: 'switch',
                    onChange: checked => {
                        this.setState({ isAgreementExpire: checked }, () => {
                            setFieldsValue({ isAgreementExpire: checked })
                        })
                    }
                },
                {
                    label: 'Expiry Date',
                    key: 'enrollmentExpiry',
                    hidden: this.state.isAgreementExpire ? false : true,
                    required: this.state.isAgreementExpire ? true : false,
                    type: 'date',
                    format: 'DD-MMM-YYYY'
                },
            ],
        };

        const newComissionSchema = {
            fields: [
                {
                    label: 'Type',
                    key: 'type',
                    type: 'select',
                    options: ['Domestic', 'International'],
                    onChange: v => {
                        setFieldsValue({ type: v })
                    }
                },
                {
                    label: 'Invoice To',
                    key: 'invoiceToName',
                },
                {
                    label: 'Invoice Address',
                    key: 'invoiceAddress',
                },
                {
                    label: 'Kind Attention',
                    key: 'kindAttention',
                },
                {
                    label: 'Invoice Email',
                    key: 'invoiceToEmail',
                },
                {
                    label: 'Invoice Country Code',
                    key: 'invoiceToPhoneCode',
                    type: 'select',
                    options: this.state.phoneCodes,
                    showSearch: true,
                    onChange: v => {
                        setFieldsValue({ invoiceToPhoneCode: v })
                    }
                },
                {
                    label: 'Invoice Contact',
                    key: 'invoiceToPhone',
                },
                {
                    label: 'Invoice Category',
                    key: 'invoiceToCategory',
                },
                {
                    label: 'Is This Default Invoice Recipient?',
                    key: 'default',
                    type: 'switch',
                    onChange: v => {
                        setFieldsValue({ default: v })
                    }
                }
            ]
        }

        const applicantListColumns = [
            {
                title: 'Type',
                key: 'type',
                dataIndex: 'type'
            },
            {
                title: 'Invoice To',
                key: 'invoiceToName',
                dataIndex: 'invoiceToName',
            },
            {
                title: 'Invoice Address',
                key: 'invoiceAddress',
                dataIndex: 'invoiceAddress',
            },
            {
                title: 'Kind Attention',
                key: 'kindAttention',
                dataIndex: 'kindAttention',
            },
            {
                title: 'Invoice Email',
                key: 'invoiceToEmail',
                dataIndex: 'invoiceToEmail',
            },
            {
                title: 'Invoice Contact',
                key: 'invoiceToPhone',
                dataIndex: 'invoiceToPhone',
                render: (text, record) => (
                    <div>{record && record.invoiceToPhoneCode}-{record && record.invoiceToPhone}</div>
                )
            },
            {
                title: 'Invoice Category',
                key: 'invoiceToCategory',
                dataIndex: 'invoiceToCategory',
            },
            {
                title: 'Default Recipient',
                key: 'default',
                render: (text, record) => (
                    <div>{record && record.default ? "Yes" : "No"}</div>
                )
            },
            {
                title: 'Action',
                key: 'operation',
                render: (text, record, index) => (
                    <>
                        <Tooltip title="Edit Billing Detail">
                            <Button shape="circle" icon='edit' onClick={() => this.editApplicant(record, index)} />
                        </Tooltip>
                        <Tooltip title="Delete Commission">
                            <Button
                                shape="circle"
                                onClick={() => {
                                    this.removeCommissionRow(index)
                                }}
                                icon="delete"
                            />
                        </Tooltip>
                    </>
                )
            }
        ]

        return (
            <PageHeaderWrapper title={"Add New Partner"}>
                {
                    this.state.showChooseUniDrawer ?
                        <AddCommDetailsInUni record={this.state.choosedUniRecord} onClose={this.closeChoosedUniDrawer} />
                        : null
                }
                {
                    this.state.showImportDrawer ?
                        <ImportCommDrawer channelPartnerId={countryId} onClose={this.closeCommImport} />
                        : null
                }
                <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>
                    <Card bordered={true}>
                        {this.state.showSave ? (
                            <Button
                                style={{ marginBottom: 10 }}
                                type="primary"
                                htmlType="submit"
                                loading={this.state.loading}
                            >
                                SAVE
                            </Button>
                        ) : null}

                        <Tabs onChange={this.callback} type="card">
                            {this.state.inputTypes.map((itype, key) => {
                                return (
                                    <TabPane tab={itype.tabTitle} key={key + 1}>
                                        <GetAllFormFields
                                            inputSchema={this.state.inputTypes[key]}
                                            refresh={this.refreshFxn}
                                            getFieldDecorator={getFieldDecorator}
                                        />
                                    </TabPane>
                                );
                            })}

                            {
                                <TabPane tab={"Partner Universities"} key={3}>
                                    <Row className={style.card}>
                                        <Col span={12}>
                                            <div>
                                                <Card title="All Universities" bordered={false}>
                                                    <Input
                                                        onChange={this.filter}
                                                        placeholder={"Search University"}
                                                    />

                                                    <div className={style.check}>
                                                        <Row>
                                                            <Col span={12}>
                                                                {" "}
                                                                <Checkbox
                                                                    indeterminate={this.state.indeterminate}
                                                                    onChange={this.onCheckAllChange}
                                                                    checked={this.state.checkAll}
                                                                >
                                                                    Check all
                                                                </Checkbox>
                                                            </Col>
                                                            <Col span={12}>
                                                                <Button size="small" onClick={this.uncheck}>
                                                                    Uncheck All
                                                                    <Icon type="close" />
                                                                </Button>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                    <Col>
                                                        <Checkbox.Group
                                                            style={{
                                                                display: "flex",
                                                                flexDirection: "column",
                                                            }}
                                                            options={this.state.uniArr.map((uni) => ({
                                                                label: uni.label,
                                                                value: uni.value,
                                                                disabled: uni.universityPartnership === "Direct", // Disable if `isDirect` is true
                                                            }))}
                                                            value={this.state.checkedList}
                                                            onChange={this.checkUni}
                                                        />
                                                    </Col>
                                                    {/* <Col>
                                <Checkbox.Group
                                style={{
                                display: "flex",
                                flexDirection: "column",
                                }}
                                options={this.state.uniArr}
                                value={this.state.checkedList}
                                onChange={this.checkUni}
                                />
                                </Col> */}
                                                </Card>
                                            </div>
                                        </Col>
                                        {/* <Col span={11} style={{ marginLeft: 5 }}>
                                    <Card title="Selected Universities" bordered={false}>
                                    <List
                                    size="small"
                                    bordered
                                    dataSource={this.state.choosenArr}
                                    renderItem={(item, index) => (
                                        <List.Item>
                                    <span style={{ marginRight: 10 }}>{index + 1}</span>
                                    <span style={{ marginRight: 10 }}>{item.label}</span>
                                    <Input
                                    placeholder="Enter commission"
                                    style={{ width: '150px' }}
                                    value={item.commission}
                                    onChange={(e) => this.handleCommissionChange(e.target.value, index)}
                                    />
                                    </List.Item>
                                    )}
                                    />
                                    </Card>
                                    </Col> */}
                                        <Col span={11} style={{ marginLeft: 5 }}>
                                            <Card title="Selected Universities" bordered={false}>
                                                <List
                                                    size="small"
                                                    bordered
                                                    dataSource={this.state.choosenArr}
                                                    renderItem={(item, index) => (
                                                        <List.Item>
                                                            <span style={{ marginRight: 10 }}>
                                                                {index + 1}
                                                            </span>
                                                            {item.label}
                                                        </List.Item>
                                                    )}
                                                />

                                                <div />
                                            </Card>
                                        </Col>

                                        {/* <Col span={12}>
                                        <Select
                                        mode="multiple"
                                        style={{ width: '100%' }}
                                        placeholder="Please select"
                                        onChange={this.handleChange}
                                        >
                                        {children}
                                        </Select>,
                                        </Col>*/}
                                    </Row>
                                </TabPane>
                            }
                            {this.state.showFiles ? (
                                <TabPane tab={"Files"} key={4}>
                                    <MasterDocuments type={"partner"} _id={countryId} types={['Agreement']} />
                                    {/* <MasterDocUtils type={"partner"} _id={countryId} /> */}
                                </TabPane>
                            ) : null}

                            <TabPane tab={"Payment Terms / Agreement"} key={5}>
                                <GetAllFormFields
                                    apiurl={LAPI_URL}
                                    inputSchema={paymentInputFields}
                                    refresh={this.refreshFxn}
                                    getFieldDecorator={getFieldDecorator}
                                />

                                {/* <Row>
                                        <Col span={6}></Col>
                                        <Col span={6}>
                                        <Row>
                                        <Col span={24}>
                                        <Button onClick={this.viewPDF}>
                                        View Agreement
                                        </Button>
                                        </Col>
                                        </Row>
                                        </Col>
                                        <Col span={6}>
                                        <Row>
                                        <Col span={24}>
                                        <Button onClick={this.viewAgreementCommissionPDF}>
                                        View Commission Page
                                        </Button>
                                        </Col>
                                        </Row>
                                        </Col>
                                        </Row> */}
                            </TabPane>

                            {/* {
                                            this.state.choosenArr && this.state.choosenArr.length > 0 ?
                                            (() => {
                                                let modifiedArr = this.state.choosenArr;
                                            return (
                                            <TabPane tab={"Selected Universities"} key={6}>
                                            <Card title="Selected Universities" bordered={false}>
                                            <List
                                            size="small"
                                            bordered
                                            dataSource={modifiedArr}
                                            renderItem={(item, index) => (
                                                <List.Item>
                                            <span style={{ marginRight: 10 }}>
                                            {index + 1}
                                            </span>
                                            {item.label}
                                            </List.Item>
                                            )}
                                            />
                                            
                                            <div />
                                            </Card>
                                            
                                            </TabPane>
                                            )
                                            })
                                            : null
                                            } */}



                            {this.state.uniCommArr && this.state.uniCommArr.length > 0 ? (
                                <TabPane tab={"Selected Universities"} key={6}>
                                    <Card>
                                        <Row gutter={16}>
                                            <Col span={6}><Button onClick={this.exportChannelPartnerComm} type="primary">Export University Commission</Button></Col>
                                            <Col span={6}><Button type="primary" onClick={this.showCommImport}>Import University Commission</Button></Col>
                                        </Row>

                                    </Card>
                                    <Card title="Selected Universities" bordered={false}>
                                        <TableComp
                                            dataSource={this.state.uniCommArr}
                                            columns={choosedUniColumn}
                                            ref={this.uniCommTable}
                                            rowKey={(record) => record.id}
                                            size="small"
                                            bordered
                                        />
                                        {/* <TableComp columns={choosedUniColumn} /> */}
                                        {/* <List
                                                    size="small"
                                                    bordered
                                                    dataSource={this.state.choosenArr}
                                                    renderItem={(item, index) => (
                                                        <List.Item>
                                                    <span style={{ marginRight: 10 }}>
                                                    {index + 1}
                                                    </span>
                                                    {item.label}
                                                    </List.Item>
                                                    )}
                                                    /> */}

                                        <div />
                                    </Card>

                                </TabPane>
                            ) : null}

                            <TabPane tab={"Billing Details"} key={7}>
                                <Card>
                                    <div className={"applicantsItem"}>

                                        <Button type='primary' onClick={() => this.setState({ showApplicantModal: true })}>Click to add</Button>
                                        <Modal
                                            title="Add Invoice Recipient Details"
                                            visible={this.state.showApplicantModal}
                                            onCancel={() => this.setState({ showApplicantModal: false })}
                                            onOk={() => this.setState({ showApplicantModal: false })}
                                            footer={[<Button
                                                type="primary"
                                                onClick={() => this.handleReferenceSubmit()}
                                                style={{ marginBottom: 10 }}
                                                loading={this.props.loading}>
                                                SAVE
                                            </Button>]}
                                        >
                                            <Form>
                                                <GetAllFormFields apiurl={LAPI_URL} inputSchema={newComissionSchema} getFieldDecorator={getFieldDecorator} />
                                            </Form>
                                        </Modal>
                                    </div>
                                    <Row style={{ marginTop: 40 }}>
                                        <Col span={24}>
                                            <Table
                                                bordered={true}
                                                style={{ width: '100%' }}
                                                columns={applicantListColumns}
                                                dataSource={this.state.applicantsList}
                                                pagination={false}
                                                scroll={{ x: 'max-content' }}
                                            />
                                        </Col>
                                    </Row>
                                </Card>
                            </TabPane>

                            {/* {
                                                    this.state.choosenArr && this.state.choosenArr.length>0?
                                                    <TabPane
                                                    :null
                                                    } */}
                        </Tabs>
                    </Card>
                </Form>
            </PageHeaderWrapper>
        );
    }
}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    categories: global.categories,
    search: router.location.search,
});

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch,
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddPartner);
